import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import {AuthService} from '../services/auth.service';
import {NGXLogger} from "ngx-logger";

@Injectable()
export class IsAuthenticatedAuthGuard  {
  constructor(
    private authService: AuthService,
    private router: Router,
    private logger: NGXLogger,
  ) {

  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise <boolean> {
    return this.authService.GetSessionInfo()
      .then(sessionInfo => {
        console.log("Auth Session", sessionInfo)
        //check if the user is authenticated, if not, redirect to login
        if (!sessionInfo) {
          if (route.url.toString() === '/auth/signin') {
            return true
          } else {
            this.logger.info("User is not authenticated, redirecting to login page")
            return this.router.navigate(['/auth/signin']);
          }
        }
        // continue as normal
        return true
      })
      .catch(err => {
        this.logger.error("error checking if user is authenticated, forcing user back to /auth/signin", err)
        return this.router.navigate(['/auth/signin']);
      })
  }
}
